import { TAgent } from '~/features/agents/models'
import { EMessageSpeaker } from '~/models/features'

const getAgentAndChatbotDetails = (agent: TAgent) => {
  const agentDetails = {
    id: agent.id,
    businessName: agent.businessName,
    agentName: agent.agentName,
    chatIntro: agent.chatIntro,
    chatbotImgURL: agent.chatbotImgURL,
    service: agent.service,
    customLinks: agent.customLinks,
    showLibby: agent.showLibby,
    showBranding: agent.showBranding,
    calendlyLink: agent.calendlyLink,
    chatStatus: agent.chatStatus,
  }

  return {
    agent: agentDetails,
    messages: [
      {
        message: agent.chatIntro ?? '',
        speaker: EMessageSpeaker.assistant,
      },
    ],
  }
}

export default getAgentAndChatbotDetails
